require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-honors-the-memory-of-judy-heumann.json") })
        }
      }, "path---en-us-update-bic-honors-the-memory-of-judy-heumann");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-honors-the-memory-of-judy-heumann!./.cache/json/en-us-update-bic-honors-the-memory-of-judy-heumann.json
// module id = 626
// module chunks = 231608221292675